/**
 * AI 生文 输入框
 * @returns
 */
import React, { useCallback, useState } from "react";
import {
  Box,
  Flex,
  IconButton,
  Input,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useToast,
} from "@chakra-ui/react";
import {
  RiArrowUpLine,
  RiEmotionHappyLine,
  RiImageLine,
} from "@remixicon/react";
import { useLocation } from "react-router-dom";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
// import "emoji-mart/dist/emoji-mart.css";
import i18n from "@emoji-mart/data/i18n/zh.json";
import { useDropzone } from "react-dropzone";
i18n.search_no_results_1 = "没有找到表情";

type Props = {
  // text: string;
  // updateValue: (text: string) => void;
  handleSubmit: (content: string) => void;
};

const SendComponent = (props: Props) => {
  const toast = useToast();
  const location = useLocation();
  const [text, setText] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setText(inputValue)
    // props.updateValue(inputValue);
  };

  const handleEmojiClick = (emoji: any) => {
    // props.updateValue(props.text + emoji.native);
    setText(text + emoji.native)
  };

  const handleDrop = useCallback(
    (acceptedFiles: File[]) => {
      // 处理接收到的文件，例如上传到服务器
      if (acceptedFiles.length > 0) {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64File = reader.result as string;
            // console.log(base64File);
            // 在这里可以对base64文件进行进一步处理或发送到服务器
            const newFile =base64File;
            props.handleSubmit(newFile);
            
          
          };
          reader.readAsDataURL(file);
        });
        
        // toast({ title: "图片已上传。", position: "top", status: "success" });
      }
    },
    [toast]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".png"],
    },
    maxFiles: 1,
    onDrop: handleDrop,
    multiple: true,
    onDropRejected: () => {
      toast({
        title: "上传的文件类型(仅支持png、jpeg)或数量不符合要求！",
        position: "top",
        status: "error",
      });
    },
  });

  return (
    <Flex
      pr="12px"
      alignItems="center"
      h="52px"
      bg="#DCE0EB"
      borderRadius={"8px"}
      gap={"12px"}
    >
      <Input
        flex={1}
        h="100%"
        fontSize={"14px"}
        color="#8E94A9"
        borderWidth="2px"
        bg="none"
        border={"none"}
        value={text}
        onChange={handleInputChange}
        placeholder="随时输入你想要了解的任何内容"
        focusBorderColor="transparent"
      />

      <Popover placement="top-end">
        <PopoverTrigger>
          <IconButton
            aria-label="emotion"
            variant={"unstyled"}
            isRound={true}
            minW={"22px"}
            boxSize="22px"
            color="#8E94A9"
            bgColor="none"
            fontWeight={"normal"}
            fontSize="12px"
            _hover={{
              color: "#3F5BC1",
            }}
            icon={<RiEmotionHappyLine size={"22px"} />}
          />
        </PopoverTrigger>
        <PopoverContent w="354px">
          <PopoverBody p="0">
            <Box>
              <Picker
                data={data}
                emojiSize={20}
                onEmojiSelect={handleEmojiClick}
                // set="apple"
                locale="zh"
                i18n={i18n}
                previewPosition="none"
                style={{ height: "300px" }} // 修改Picker的高度
              />
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>
      <Flex w="22px" h="22px" {...getRootProps()} justifyContent="center">
        <input {...getInputProps()} />
        <IconButton
          variant={"unstyled"}
          aria-label="image"
          isRound={false}
          minW={"22px"}
          boxSize="22px"
          color="#8E94A9"
          bgColor="none"
          fontWeight={"normal"}
          fontSize="12px"
          _hover={{
            color: "#3F5BC1",
            bgColor: "none",
          }}
          icon={<RiImageLine size={"22px"} />}
        />
      </Flex>

      <IconButton
        aria-label="send"
        isRound={true}
        minW={"22px"}
        // width={"46px"}
        // height={"32px"}
        boxSize="22px"
        color="#FFFFFF"
        bgColor="#496AE1"
        fontWeight={"normal"}
        fontSize="12px"
        _hover={{
          bgColor: "#3F5BC1",
          color: "#E6E6E6",
        }}
        onClick={()=>props.handleSubmit(text)}
        icon={<RiArrowUpLine size={"16px"} />}
      >
        发送
      </IconButton>
    </Flex>
  );
};

export default SendComponent;
